import React, { FC } from "react";
import { Grid, Skeleton } from "../../components";
import stl from "./index.module.scss";

const SupplementSkeleton: FC = () => {
  return (
    <div className={stl.block}>
      <div className={stl.imgWrap}>
        <Skeleton height={150} />
      </div>
      <div className={stl.contentWrap}>
        <Skeleton
          height={"1.2em"}
          width={"90%"}
          style={{ marginBottom: "1em" }}
        />

        <Skeleton
          height={"1em"}
          width={"90%"}
          style={{ marginBottom: "1em" }}
        />

        <Grid container gutter={[10, 10]} className={stl.controls}>
          <Grid item sm={6} xs={12}>
            <Skeleton height={50} />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default SupplementSkeleton;
